import { render, staticRenderFns } from "./attachment-info.vue?vue&type=template&id=58463266&"
import script from "./attachment-info.vue?vue&type=script&lang=js&"
export * from "./attachment-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports